const PAPERWORK_INCREMENT_PROGRESS_BAR = 'paperwork/INCREMENT_PROGRESS_BAR';
const PAPERWORK_SET_PAGE_VIEW = 'paperwork/SET_PAGE_VIEW';
const PAPERWORK_TOGGLE_FINALIZE_EDIT_MODE = 'paperwork/TOGGLE_FINALIZE_EDIT_MODE';
const PAPERWORK_SEND_FORM_DATA_TO_STATE = 'paperwork/SEND_FORM_DATA_TO_STATE';
const PAPERWORK_INITIALIZING_DATA = 'paperwork/INITIALIZING_DATA';
const PAPERWORK_SUBMITTING_PAGE = 'paperwork/SUBMITTING_PAGE';
const PAPERWORK_LOCATION_PAPERWORK_FIELDS_RECEIVED = 'paperwork/LOCATION_PAPERWORK_FIELDS_RECEIVED';
const PAPERWORK_LOCATION_PAPERWORK_FIELDS_ERROR = 'paperwork/LOCATION_PAPERWORK_FIELDS_ERROR';
const PAPERWORK_CONSENT_FORM_SIGNATURES_ERROR = 'paperwork/CONSENT_FORM_SIGNATURES_ERROR';
const PAPERWORK_CONSENT_FORM_SIGNATURES_SUCCESS = 'paperwork/CONSENT_FORM_SIGNATURES_SUCCESS';
const PAPERWORK_LOCATION_CONSENT_FORMS_ERROR = 'paperwork/LOCATION_CONSENT_FORMS_ERROR';
const PAPERWORK_LOCATION_CONSENT_FORMS_RECEIVED = 'paperwork/LOCATION_CONSENT_FORMS_RECEIVED';
const PAPERWORK_RESET_STATE = 'paperwork/RESET_STATE';

const incrementProgressBar = value => ({
  type: PAPERWORK_INCREMENT_PROGRESS_BAR,
  payload: { value },
});

const setPageView = value => ({
  type: PAPERWORK_SET_PAGE_VIEW,
  payload: { value },
});

const toggleFinalizeEditMode = value => ({
  type: PAPERWORK_TOGGLE_FINALIZE_EDIT_MODE,
  payload: { value },
});

const sendDataToState = value => ({
  type: PAPERWORK_SEND_FORM_DATA_TO_STATE,
  payload: { value },
});

const initializingData = () => ({
  type: PAPERWORK_INITIALIZING_DATA,
});

const isSubmittingPaperworkPage = value => ({
  type: PAPERWORK_SUBMITTING_PAGE,
  payload: { value },
});

const locationPaperworkFieldsReceived = value => ({
  type: PAPERWORK_LOCATION_PAPERWORK_FIELDS_RECEIVED,
  payload: { value },
});

const locationPaperworkFieldsError = value => ({
  type: PAPERWORK_LOCATION_PAPERWORK_FIELDS_ERROR,
  payload: { value },
});

const locationConsentFormsReceived = value => ({
  type: PAPERWORK_LOCATION_CONSENT_FORMS_RECEIVED,
  payload: { value },
});

const locationConsentFormsError = value => ({
  type: PAPERWORK_LOCATION_CONSENT_FORMS_ERROR,
  payload: { value },
});

const consentFormSignaturesSuccess = () => ({
  type: PAPERWORK_CONSENT_FORM_SIGNATURES_SUCCESS,
});

const consentFormSignaturesError = () => ({
  type: PAPERWORK_CONSENT_FORM_SIGNATURES_ERROR,
});

const resetPaperworkState = () => ({ type: PAPERWORK_RESET_STATE });

const getInitialState = () => ({
  pageView: 0,
  formData: {},
  isInFinalizeEditMode: false,
  percentCompleted: 0,
  isSubmitting: false,
});

export default (state = getInitialState(), action) => {
  switch (action.type) {
    case PAPERWORK_INITIALIZING_DATA:
      return {
        ...state,
        initializing: true,
      };
    case PAPERWORK_SUBMITTING_PAGE:
      return {
        ...state,
        isSubmitting: action.payload.value,
      };
    case PAPERWORK_INCREMENT_PROGRESS_BAR:
      return {
        ...state,
        percentCompleted: action.payload.value,
      };
    case PAPERWORK_TOGGLE_FINALIZE_EDIT_MODE:
      return {
        ...state,
        isInFinalizeEditMode: action.payload.value,
      };
    case PAPERWORK_SET_PAGE_VIEW:
      return {
        ...state,
        pageView: action.payload.value,
      };
    case PAPERWORK_SEND_FORM_DATA_TO_STATE: {
      let formData = state.formData ? { ...state.formData } : {};
      for (const formField in action.payload.value) {
        if (action.payload.value) {
          formData[formField] = action.payload.value[formField];
        }
      }

      return {
        ...state,
        formData,
      };
    }
    case PAPERWORK_LOCATION_PAPERWORK_FIELDS_RECEIVED:
      return {
        ...state,
        standardFields: action.payload.value.filter(field => field.is_standard_field),
        customFields: action.payload.value.filter(field => !field.is_standard_field),
        initializing: false,
      };
    case PAPERWORK_LOCATION_PAPERWORK_FIELDS_ERROR:
      return {
        ...state,
        error: action.payload.value,
        initializing: false,
      };

    case PAPERWORK_LOCATION_CONSENT_FORMS_RECEIVED:
      return {
        ...state,
        consentForms: action.payload.value,
      };

    case PAPERWORK_LOCATION_CONSENT_FORMS_ERROR:
      return {
        ...state,
        consentForms: {
          error: action.payload.value,
        },
      };

    case PAPERWORK_CONSENT_FORM_SIGNATURES_SUCCESS:
      return {
        ...state,
        signatures: {
          error: false,
          success: true,
        },
      };

    case PAPERWORK_CONSENT_FORM_SIGNATURES_ERROR:
      return {
        ...state,
        signatures: {
          error: true,
          success: false,
        },
      };

    case PAPERWORK_RESET_STATE:
      return {
        ...state,
        ...getInitialState(),
      };

    default:
      return state;
  }
};

export {
  incrementProgressBar,
  toggleFinalizeEditMode,
  setPageView,
  sendDataToState,
  initializingData,
  isSubmittingPaperworkPage,
  locationPaperworkFieldsReceived,
  locationPaperworkFieldsError,
  locationConsentFormsReceived,
  locationConsentFormsError,
  consentFormSignaturesSuccess,
  consentFormSignaturesError,
  resetPaperworkState,
};
